document.querySelectorAll('form[role="search"]').forEach(form => {
  const input = form.querySelector('input[type="search"]');
  const resetButton = form.querySelector('button[type="reset"]');

  if (!input) return;

  // 入力のデバウンス処理（必要に応じて）
  input.addEventListener('input', debounce(() => {
    // このフォーム内だけで表示・非表示を制御
    if (resetButton) {
      resetButton.classList.toggle('hidden', input.value.length === 0);
    }
  }, 300));

  // リセットボタンの挙動制御
  form.addEventListener('reset', e => {
    e.preventDefault(); // 本来の reset を止める
    input.value = '';
    if (resetButton) resetButton.classList.add('hidden');
    input.focus();
  });

  // フォーム送信時の挙動も制御（任意で）
  form.addEventListener('submit', e => {
    e.preventDefault();
    const query = input.value.trim();
    const params = new URLSearchParams();
    if (query !== '') {
      if (form.closest('search-form')?.hasAttribute('data-sku-search')) {
        params.set('q', 'variants.sku:' + query);
      } else {
        params.set('q', query);
      }
    }
    params.set('type', 'product');
    const action = form.getAttribute('action') || '/search';
    window.location.href = action + '?' + params.toString();
  });
});

// デバウンス関数
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}
